import SkipIcon from '@mui/icons-material/Redo';
import Button from '@mui/material/Button';

const SkipButton = ({ handleSkip }) => {
	return (
		<Button
			sx={{
				color: '#ffffff',
				minWidth: '130px',
				display: 'flex',
				marginLeft: 'auto',
				marginRight: '16px'
			}}
			variant="contained"
			onClick={handleSkip}
		>
			Skip
			<SkipIcon
				sx={{
					width: '18px',
					color: '#ffffff',
					marginLeft: '5px'
				}}
			/>
		</Button>
	);
};

export default SkipButton;
